import InvoicesItem from "../components/Invoices/InvoicesItem";
import { invoicePeriods } from "../endpoints";
import useFetch from "../hooks/useFetch";
import { useClickFilter } from "../hooks/filtering";
import { useSearchBar } from "../hooks/search";

interface InvoiceData {
  period: string;
}

const InvoicesLayout = () => {
  const { data, loading } = useFetch<InvoiceData>(invoicePeriods);

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    handleFilterClick,
    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);
  
  const {
    dateSort,
    toggleDateSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

  // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };

  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Facturen laden...</span>
                ) : (
                  `Facturen`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle Facturen"
              )}
            </p>
          </div>
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
            {/* Search area */}
            <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
              <input
                className="h-6 w-[80%] m-auto focus:outline-none"
                onChange={(e) => setSearchEntry(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                value={searchEntry}
                placeholder="Zoeken..."
              />
            </div>

            {/* Filters */}
            {shouldShowFilters && (
              <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                <b className="text-gray-600 text-xs">Filters</b>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                >
                  <b>Geen specefieke filters mogelijk op het moment</b>
                  <div className="flex text-xs">
                    <b>Zoeken is wel mogelijk</b>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
          {data.length > 0 && !loading && (
            <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
              <div
                className="w-1/12 flex cursor-pointer select-none"
                onClick={toggleDateSort}
              >
                <b>Periode</b>
                {getArrow(dateSort) && (
                  <img
                    src={getArrow(dateSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
            </div>
          )}
          {loading ? (
            <div className="min-w-full bg-gray-200 p-4 font-semibold text-gray-700 dark:text-gray-300 rounded-xl mt-1 animate-pulse">
              <p>Facturen laden...</p>
            </div>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={6}
                className="p-4 text-center text-gray-500 text-xl font-semibold"
              >
                Geen Facturen
              </td>
            </tr>
          ) : (
            getFilteredAndSortedData().map((invoice, index) => (
              <InvoicesItem key={index} period={invoice.period} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoicesLayout;
